module.exports = __webpack_public_path__ + "img/number_date.d1d2222c.svg";